import { render, staticRenderFns } from "./DoctorRegisterRecordForm.vue?vue&type=template&id=26bbdb1a&"
import script from "./DoctorRegisterRecordForm.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports